<template>
    <div class="c-services-comment component">
        <h3 class="text--upper">Komentarz</h3>
        <div class="flex-row">
            <div class="flex-col mt--2">
                <input type="text" placeholder="Tutaj wpisz swój komentarz" v-model="lead.comment_val">
            </div>
        </div>
    </div>
</template>
<script>
import lead from '@/mixins/lead.js'

export default {
    mixins: [lead]
}
</script>
<style lang="scss">
.c-services-comment {}
</style>